import React, {useState, useEffect} from "react";
import {Button, Col, Form, Row, Select, Space, message} from "antd";
import {EditOutlined, CheckOutlined, CloseOutlined} from "@ant-design/icons";
import {useTranslation} from "react-i18next";
import {useFetch} from "hooks/useFetch";
import {useStore} from "hooks/useStore";

const CourierSummaryWorkingModel = ({
    workingModel: initialWorkingModel,
    workingModelId: initialWorkingModelId,
    selectedWorkingModelId,
    onSave
}) => {
    const {t} = useTranslation();
    const [isEditing, setIsEditing] = useState(false);
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const stores = useStore();

    const [workingModelsLoading, workingModelsData] = useFetch({
        defaultDataValue: {result: []},
        fetchFn: stores.courierStore.listWorkingModels.bind(null, {isActive: true}),
        initialCall: true
    });

    const workingModels = workingModelsData?.result || [];

    const resolvedValue =
        selectedWorkingModelId !== undefined ? selectedWorkingModelId : initialWorkingModelId;

    useEffect(() => {
        form.setFieldsValue({
            workingModelId: resolvedValue ?? undefined
        });
    }, [resolvedValue]);

    const displayLabel = () => {
        const fromList = workingModels.find(
            wm => wm?._id?.toString() === resolvedValue?.toString()
        );
        if (fromList?.label?.tr) return fromList.label.tr;
        if (initialWorkingModel?.label?.tr) return initialWorkingModel.label.tr;
        return "-";
    };

    const handleEdit = () => {
        form.setFieldsValue({workingModelId: resolvedValue ?? undefined});
        setIsEditing(true);
    };

    const handleCancel = () => {
        setIsEditing(false);
        form.resetFields();
    };

    const handleSubmit = async values => {
        try {
            setLoading(true);
            await onSave({workingModelId: values.workingModelId ?? null});
            setIsEditing(false);
        } catch (error) {
            console.error("Error updating working model:", error);
            message.error(
                error.response?.data?.message || t("Çalışma zamanı güncellenirken bir hata oluştu")
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <Form
            form={form}
            onFinish={handleSubmit}
            initialValues={{workingModelId: resolvedValue ?? undefined}}
        >
            <Row gutter={[8, 8]} align="middle">
                <Col flex="auto">
                    {isEditing ? (
                        <Form.Item name="workingModelId" style={{marginBottom: 0}}>
                            <Select
                                allowClear
                                showSearch
                                loading={workingModelsLoading}
                                placeholder="Seçiniz"
                                style={{width: "100%", maxWidth: 260}}
                                filterOption={(input, option) =>
                                    (option?.children ?? "")
                                        .toString()
                                        .toLowerCase()
                                        .indexOf(input.toLowerCase()) >= 0
                                }
                            >
                                {workingModels.map(option => (
                                    <Select.Option key={option._id} value={option._id}>
                                        {option?.label?.tr}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                    ) : (
                        <div style={{padding: "5px 0"}}>{displayLabel()}</div>
                    )}
                </Col>
                <Col>
                    {stores.meStore.checkRole("updateCourier") &&
                        stores.meStore.checkPermission("couriers.edit") &&
                        (isEditing ? (
                            <Space>
                                <Button
                                    type="text"
                                    icon={<CheckOutlined />}
                                    htmlType="submit"
                                    loading={loading}
                                />
                                <Button
                                    type="text"
                                    icon={<CloseOutlined />}
                                    onClick={handleCancel}
                                    disabled={loading}
                                />
                            </Space>
                        ) : (
                            <Button type="text" icon={<EditOutlined />} onClick={handleEdit} />
                        ))}
                </Col>
            </Row>
        </Form>
    );
};

export default CourierSummaryWorkingModel;
